import React, { useState, useEffect } from "react";
import Modal from "../../layouts/Modal/Modal";
import ButtonComponent from "../../Styles/Form/ButtonComponent";
import InputComponent from "../../Styles/Form/InputComponent";
import Loading from "../../layouts/Loading/Loading";
import axios from "axios";

function CategoryCategory() {
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [newCategory, setNewCategory] = useState({});
    const [editCategory, setEditeCategory] = useState({});
    const [allCategory, setAllCategory] = useState(null);
    const editeCategoryHandler = () => {
      axios
        .put(
          `https://carpet.bistatechnology.ir/api/v1/admin/category/${selectedItem.id}`,
          editCategory
        )
        .then((res) => {
          console.log(res);
          getAllCategory();
          alert("ویرایش انجام شد");
        })
        .catch(() => {
          alert("خطا");
        })
        .finally(() => {
          setShowEditModal(false);
          setSelectedItem(null);
          setEditeCategory(null);
        });
    };
  
    const getAllCategory = () => {
      axios
        .get("https://carpet.bistatechnology.ir/api/v1/admin/category")
        .then((res) => {
          setAllCategory(res.data);
        })
        .catch(() => {
          alert("خطا در دریافت اطلاعات");
        });
    };
  
    const deleteCategoryHandler = () => {
      axios
        .delete(
          `https://carpet.bistatechnology.ir/api/v1/admin/category/${selectedItem.id}`
        )
        .then((res) => {
          console.log(res);
          getAllCategory();
          setShowAddModal(false);
          alert("حذف شد");
        })
        .catch(() => {
          alert("خطا");
        })
        .finally(() => {
          setSelectedItem(null);
        });
    };
  
    useEffect(() => {
      getAllCategory();
    }, []);
  
    const handleSelectRow = (item) => {
      setSelectedItem(item);
    };
  
    const deleteItemHandler = () => {
      if (window.confirm(` آیا فرش "${selectedItem.title}" حذف گردد؟`)) {
        deleteCategoryHandler();
      }
    };
  
    const changeEditeHandler = (e) => {
      const value = e.target.value;
      const name = e.target.name;
      setEditeCategory({ ...editCategory, [name]: value });
    };
    const CreateCategoryHandler = () => {
      axios
        .post(`https://carpet.bistatechnology.ir/api/v1/admin/category`, newCategory)
        .then((res) => {
          console.log(res);
          alert("ثبت موفق", "دسته بندی جدید با موفقیت ثبت شد");
          setShowAddModal(false)
          newCategory(null);
        })
        .catch((err) => {
          console.log(err.response.status);
          alert("خطا", "    ثبت نشد", "error");
        });
    };
    const changeInputHandler = (e) => {
      const value = e.target.value;
      const name = e.target.name;
      setNewCategory({ ...newCategory, [name]: value });
    };
    return (
      <div className="customized-container">
        <div className="customized-wrapper">
          <h5 className="title-session">لیست دسته بندی </h5>
          {showAddModal && (
            <Modal>
              <div className="d-flex flex-row flex-wrap">
                <InputComponent
                  inputName="title"
                  inputId="title"
                  lableValue="نام دسته بندی:"
                  onChange={(e) => changeInputHandler(e)}
                />
                <div>
                <ButtonComponent
                  value="ثبت"
                  onClick={() => CreateCategoryHandler()}
                />
                <ButtonComponent
                  value="لغو"
                  onClick={() => setShowAddModal(false)}
                />
                </div>
              </div>
            </Modal>
          )}
          {showEditModal && (
            <Modal>
              <div className="d-flex flex-row flex-wrap">
                <InputComponent
                  inputName="title"
                  inputId="title"
                  lableValue="نام دسته بندی:"
                  onChange={(e) => changeEditeHandler(e)}
                  defaultValue={selectedItem.title}
                />
                <ButtonComponent
                  value="ثبت"
                  onClick={() => editeCategoryHandler()}
                />
                <ButtonComponent
                  value="لغو"
                  onClick={() => setShowEditModal(false)}
                />
              </div>
            </Modal>
          )}
          <div className="d-flex flex-row ">
            <button
              className="bi-custom-button"
              onClick={() => setShowAddModal(true)}
            >
              اضافه کردن
            </button>
            <button
              className="bi-custom-button"
              onClick={() =>
                selectedItem
                  ? setShowEditModal(true)
                  : alert("جهت ویرایش یک آیتم را انتخاب کنید!")
              }
            >
              ویرایش
            </button>
            <button
              className="bi-custom-button"
              onClick={() =>
                selectedItem
                  ? deleteItemHandler()
                  : alert("جهت حذف یک آیتم را انتخاب کنید!")
              }
            >
              حذف
            </button>
          </div>
          {allCategory === null ? (
            <Loading />
          ) : (
            <table className="bi-table-style bi-row-select-enable col-12 col-md-6 col-lg-4">
              <thead>
                <tr>
                  <th> ایدی</th>
                  <th>نام دسته بندی</th>
                </tr>
              </thead>
              <tbody>
                {allCategory.map((Category, index) => {
                  return (
                    <tr
                      id={Category.id}
                      onClick={() => handleSelectRow(Category)}
                      className={
                        selectedItem?.id === Category.id ? "item-slected" : null
                      }
                    >
                      <td>{Category.id}</td>
                      <td>{Category.title}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    );
  }

export default CategoryCategory